export * from './datei-gespeichert.interface';
